import { observable } from 'mobx'

class ApplyModStore {
  /** 未安装当前mod对应游戏提示弹窗 */
  @observable
  noMODGameModalvisile: boolean = false
  /** 应用失败弹窗 */
  @observable
  applyErrorVisible: boolean = false
  /** 确定应用mod弹窗 */
  @observable
  applyMODVisible: boolean = false

  @observable
  applyMODStatusLoading: 'normal' | 'loading' | 'checking' | 'applying' = 'normal'

  @observable
  isModTab: boolean = false

  @observable
  applyMODNeedInfo: {
    platform?: string
    applyPath?: string
    modPackagePw?: string
    gameName?: string
    appId?: string
    goodsId?: string
    // modSize?: string
  } = {}

  @observable
  checkMODMd5Result:
    | {
        status: '0' | '1'
        modName: string
        modMd5: string
        gameId: number
        modLocalPath: string
        modPackagePw: string
      }
    | undefined = undefined

  @observable
  applyMODResult: {
    status?: '0' | '1'
    modName?: string
    gameId?: number
    modMd5?: string
    errCode?: TapplyMODErrCode
    errMsg?: string
  } = {}

  @observable
  applyMODProgress: { modName: string; gameId: number; modMd5: string; total: number; current: number } | undefined =
    undefined
  /** 当前应用中的mod来源与哪个页面（主要用于回跳到原页面） */
  @observable
  currentApplyModPosition: { origin: 'start' | 'knapsack'; gameLibraryId?: number; goodsId?: number } | undefined =
    undefined

  /** 检测Mod超时定时器 */
  @observable
  checkModMd5Timer: number | null = null
  @observable
  checkModMd5TimeNum: number = 60

  /** 应用Mod超时定时器 */
  @observable
  applyModMd5Timer: number | null = null
  @observable
  applyModMd5TimeNum: number = 300

  /** 检测游戏是否安装定时器 */
  @observable
  checkGameInstallTimer: number | null = null
  @observable
  checkGameInstallTimeNum: number = 5
}

export default new ApplyModStore()
